import {Injectable} from '@angular/core';
import {forkJoin, tap} from 'rxjs';
import {BaseService} from '../../api/services/base.service';
import {SessionStorageService} from './session-storage.service';
import {storageKey} from '../../api/enum/storage.constants';
import {InstitutesService} from '../../api/services/institutes.service';
import {StudentsService} from "../../api/services/students.service";
import {AdmissionsService} from "../../api/services/admissions.service";

@Injectable({providedIn: 'root'})
export class AppInitService {
    constructor(
        private baseApi: BaseService,
        private instituteApi: InstitutesService,
        private studentApi: StudentsService,
        private admissionApi: AdmissionsService,
        private storage: SessionStorageService,
    ) {
    }

    init() {
        return forkJoin({
            enumData: this.baseApi.getBaseEnum(),
            cityStateData: this.baseApi.getCityState(),
            instituteEnumData: this.instituteApi.getInstituteEnum(),
            studentEnumData: this.studentApi.getStudentEnum(),
            admissionEnumData: this.admissionApi.getAdmissionEnum(),
        }).pipe(
            tap(data => {
                this.storage.set(storageKey.enumData, data.enumData);
                this.storage.set(storageKey.cityState, data.cityStateData);
                this.storage.set(storageKey.instituteEnumData, data.instituteEnumData);
                this.storage.set(storageKey.studentEnumData, data.studentEnumData);
                this.storage.set(storageKey.admissionEnumData, data.admissionEnumData);
            })
        );
    }
}
